import six from '../assets/svg/experience/noibi.jpeg';

export const headerData = {
  name: 'AbdulSalaam Noibi',
  title: 'BackEnd Developer',
  desciption:
    'Hello! I am AbdulSalaam Noibi, a professional and passionate BackEnd Developer that Loves building micro Web Services. ',
  image: six,
  imagebw: six,
  resumePdf:
    '',
};
